import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { EnumIroType } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Iro',
  props: {
    iro: null
  },
  setup: function setup(__props) {
    var props = __props;
    var iroType = computed(function () {
      return props.iro && props.iro.type ? props.iro.type : null;
    });
    var iroName = computed(function () {
      return props.iro && props.iro.name ? props.iro.name : '';
    });
    var iroId = computed(function () {
      return props.iro && props.iro.id ? props.iro.id : null;
    });
    var iroEditPath = computed(function () {
      return props.iro && props.iro.id ? "/csrd/iro/".concat(props.iro.id, "/edit") : '#';
    });
    return {
      __sfc: true,
      props: props,
      iroType: iroType,
      iroName: iroName,
      iroId: iroId,
      iroEditPath: iroEditPath,
      EnumIroType: EnumIroType
    };
  }
});